import { apiClient } from '@/lib/api/client'
import type { TaskFieldModuleCatalogItem } from '@/components/helpdesk/TicketDetail/tasks/modules/types'

type ApiResponse<T> = { success: boolean; data?: T; message?: string }

export const taskFieldModuleService = {
  async listHelpdesk(): Promise<TaskFieldModuleCatalogItem[]> {
    const res = await apiClient.get<ApiResponse<TaskFieldModuleCatalogItem[]>>('/helpdesk/task-field-modules')
    const data = res.data?.data ?? res.data
    return Array.isArray(data) ? data : []
  },

  async listCatalog(params?: { search?: string; per_page?: number; custom_only?: boolean }): Promise<TaskFieldModuleCatalogItem[]> {
    const res = await apiClient.get<ApiResponse<TaskFieldModuleCatalogItem[]>>('/service-catalog/task-field-modules', {
      params,
    })
    const data = res.data?.data ?? res.data
    return Array.isArray(data) ? data : []
  },

  async get(id: number): Promise<TaskFieldModuleCatalogItem> {
    const res = await apiClient.get<ApiResponse<TaskFieldModuleCatalogItem>>(`/service-catalog/task-field-modules/${id}`)
    if (!res.data?.data) throw new Error(res.data?.message ?? 'Failed to load module')
    return res.data.data
  },

  async create(payload: Partial<TaskFieldModuleCatalogItem> & { module_key: string; label: string }): Promise<TaskFieldModuleCatalogItem> {
    const res = await apiClient.post<ApiResponse<TaskFieldModuleCatalogItem>>('/service-catalog/task-field-modules', payload)
    if (!res.data?.data) throw new Error(res.data?.message ?? 'Failed to create module')
    return res.data.data
  },

  async update(id: number, payload: Partial<TaskFieldModuleCatalogItem>): Promise<TaskFieldModuleCatalogItem> {
    const res = await apiClient.put<ApiResponse<TaskFieldModuleCatalogItem>>(`/service-catalog/task-field-modules/${id}`, payload)
    if (!res.data?.data) throw new Error(res.data?.message ?? 'Failed to update module')
    return res.data.data
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/service-catalog/task-field-modules/${id}`)
  },
}
